module.exports = __webpack_public_path__ + "media/images/official/about_mv_sp-42e0356030f7d1d904400875b28b6a5b.jpg";